import {normalizeDesign,LENGTHS,FINISHES,DECORATIONS} from './design-model.js';
const rounded=n=>Math.round((n+Number.EPSILON)*100)/100;
const label=(items,id)=>items.find(x=>x.id===id)?.name||id;
export const pricingAmount=value=>typeof value==='number'&&Number.isFinite(value)&&value>=0?rounded(value):null;
export function priceDesign(value,table){
 const d=normalizeDesign(value),rules=new Map((table?.rules||[]).map(r=>[r.key,r])),items=new Map();
 function add(key,fallback,unit,finger){
  if(!items.has(key))items.set(key,{key,label:rules.get(key)?.label||fallback,unit,count:0,unitAmount:pricingAmount(rules.get(key)?.amount),amount:null,fingerIndices:[]});
  const row=items.get(key);row.count++;if(Number.isInteger(finger)&&!row.fingerIndices.includes(finger))row.fingerIndices.push(finger);
 }
 add('base','十指基础套价','set');add('length.'+d.length,label(LENGTHS,d.length)+'长度','set');
 d.nails.forEach((n,i)=>{
  const finishes=new Set([n.finish]);if(n.catEye.enabled)finishes.add('cat-eye');if(n.french.enabled)finishes.add('french');
  finishes.forEach(id=>add('finish.'+id,label(FINISHES,id),'finger',i));
  if(n.gradient.enabled)add('craft.gradient','渐变配色','finger',i);
  const layers=n.layers.filter(l=>l.visible!==false&&l.opacity!==0);
  if(layers.some(l=>l.kind==='stroke'&&l.points?.length))add('craft.handpaint','自由手绘','finger',i);
  if(layers.some(l=>l.kind==='pattern'))add('craft.pattern','图案绘制','finger',i);
  for(const l of layers){
   if(l.kind==='charm')add('decoration.'+l.type,label(DECORATIONS,l.type),'piece',i);
   if(l.kind==='sticker'&&d.assets[l.assetId])add('craft.sticker','图片贴纸','piece',i);
  }
 });
 const lines=[...items.values()].map(row=>({...row,amount:row.unitAmount===null?null:rounded(row.unitAmount*row.count)}));
 const knownSubtotal=rounded(lines.reduce((n,l)=>n+(l.amount??0),0)),unknownLines=lines.filter(l=>l.amount===null);
 return {status:unknownLines.length?'needs_quote':'estimated',revision:table?.revision||'',currency:table?.currency||'USD',knownSubtotal,total:unknownLines.length?null:knownSubtotal,lines,unknownLines};
}
export function priceCart(items,table){
 const rows=items.map(item=>({...item,pricing:item.kind==='custom'?priceDesign(item.customization,table):{status:'estimated',total:item.unitPrice,knownSubtotal:item.unitPrice,lines:[],unknownLines:[]}}));
 const knownSubtotal=rounded(rows.reduce((n,x)=>n+x.pricing.knownSubtotal*x.quantity,0));
 return {items:rows,knownSubtotal,total:rows.some(x=>x.pricing.total===null)?null:knownSubtotal,status:rows.some(x=>x.pricing.total===null)?'needs_quote':'estimated'};
}
